module.exports = __webpack_public_path__ + "static/media/28DGC12.94734e55.jpg";